import type { OaDecision } from '../opportunity-assessment.models';
import type { OpportunityAssessmentDecisionStatus } from './opportunity-assessment-api.models';

export function decisionToApi(decision: OaDecision): OpportunityAssessmentDecisionStatus {
  switch (decision) {
    case 'go':
      return 'Go';
    case 'no-go':
      return 'NoGo';
    case 'back-to-qual':
      return 'ReQualify';
    default:
      return 'Pending';
  }
}

export function decisionFromApi(status: OpportunityAssessmentDecisionStatus): OaDecision {
  switch (status) {
    case 'Go':
      return 'go';
    case 'NoGo':
      return 'no-go';
    case 'ReQualify':
      return 'back-to-qual';
    default:
      return null;
  }
}
